import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { QUERY_KEYS } from '@hero/constants';
import { recognitionServices } from '@hero/services';
import { useNotification } from '@hero/store/hooks';

export const useDeleteRecognition = ({ options = {} } = {}) => {
  const queryClient = useQueryClient();
  const { showSuccess } = useNotification();
  const { t } = useTranslation();

  return useMutation(code => recognitionServices.delete(code), {
    ...options,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.useGetRecognitionsKey] });
      showSuccess({
        message: t('xDeletedSuccessfully', { type: t('oneTimeGift') }),
        type: 'toast'
      });
    }
  });
};
